import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const GST = () => {
  return (
    <>
      <TopBanner content={"GST"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>One Nation, One Tax</h2>
          <p>
            GST is an indirect tax that is charged on the supply of goods and
            services in India. It replaced many earlier taxes like VAT, Service
            Tax, and Excise Duty creating a unified tax system across the
            country.
          </p>
          <p>
            It’s applicable at every stage of a product or service from
            manufacturer to end consumer and is collected by businesses on
            behalf of the government.
          </p>

          <h3>Key Points:</h3>
          <ul>
            <li>GST is charged on sales, purchases, and services</li>
            <li>
              Businesses with turnover above ₹20–40 lakhs (depending on the
              state) must register
            </li>
            <li>GST returns must be filed monthly or quarterly </li>
            <li>There are 4 main GST rates: 5%, 12%, 18%, and 28%</li>
            <li>
              Input Tax Credit (ITC) allows businesses to reduce tax paid on
              purchases
            </li>
          </ul>

          <p>
            GST has simplified tax filing and increased transparency but staying
            compliant is key.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default GST;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
